<template>
  <div>
    <app-banner title="Web Affiliate Badge" />
    <section class="content-wrapper">
      <div class="content">
        <p class="p3">
          Select your choice below, then click “Get Code.”
        </p>
        <div class="flex">
          <input type="radio" id="one" value="a" v-model="selected" />
          <label for="one" class="one">
            <img
              :src="`${$assets}affiliate-button-${size}_a@1x.jpg`"
              :srcset="`${$assets}affiliate-button-${size}_a@2x.jpg 2x`"
              alt="Banner option 1"
              class="badge-img"
            />
          </label>
          <input type="radio" id="two" value="b" v-model="selected" />
          <label for="two" class="two">
            <img
              :src="`${$assets}affiliate-button-${size}_b@1x.jpg`"
              :srcset="`${$assets}affiliate-button-${size}_b@2x.jpg 2x`"
              alt="Banner option 2"
              class="badge-img"
            />
          </label>
          <template v-if="size !== '120x60'">
            <input type="radio" id="three" value="c" v-model="selected" />
            <label for="three" class="three">
              <img
                :src="`${$assets}affiliate-button-${size}_c@1x.jpg`"
                :srcset="`${$assets}affiliate-button-${size}_c@2x.jpg 2x`"
                alt="Banner option 3"
                class="badge-img"
              />
            </label>
            <input type="radio" id="four" value="d" v-model="selected" />
            <label for="four" class="four">
              <img
                :src="`${$assets}affiliate-button-${size}_d@1x.jpg`"
                :srcset="`${$assets}affiliate-button-${size}_d@2x.jpg 2x`"
                alt="Banner option 4"
                class="badge-img"
              />
            </label>
            <input type="radio" id="five" value="e" v-model="selected" />
            <label for="five" class="five">
              <img
                :src="`${$assets}affiliate-button-${size}_e@1x.jpg`"
                :srcset="`${$assets}affiliate-button-${size}_e@2x.jpg 2x`"
                alt="Banner option 5"
                class="badge-img"
              />
            </label>
            <input type="radio" id="six" value="f" v-model="selected" />
            <label for="six" class="six">
              <img
                :src="`${$assets}affiliate-button-${size}_f@1x.jpg`"
                :srcset="`${$assets}affiliate-button-${size}_f@2x.jpg 2x`"
                alt="Banner option 6"
                class="badge-img"
              />
            </label>
          </template>
        </div>
        <button class="btn" @click="nextPage">Get Code</button>
        <p v-if="validated" class="alert">
          Select an option to continue
        </p>
        <a class="link" @click="prevPage">‹ Back</a>
      </div>
      <img
        :src="`${$assets}img-affiliate-4@1x.jpg`"
        :srcset="`${$assets}img-affiliate-4@2x.jpg 2x`"
        alt="Woman on a Single Pedal EXO Chair"
        class="wide photo"
      />
    </section>
  </div>
</template>

<script>
import AppBanner from "@/components/AppBanner.vue";

export default {
  name: "StepFour",

  props: {
    size: String
  },

  components: {
    AppBanner
  },

  data() {
    return {
      selected: "",
      validated: ""
    };
  },

  methods: {
    nextPage() {
      if (this.selected) {
        this.validated = "";
        this.$bus.$emit("image", this.selected);
        this.$emit("clicked", "five");
      } else {
        this.validated = true;
      }
    },

    prevPage() {
      this.$emit("clicked", "three");
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  display: flex;
  justify-content: center;
}

.content {
  padding: 50px 32px;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
}

label {
  display: inline-block;
  font-family: sans-serif, Arial;
  font-size: 16px;
  /* border: 1px solid var(--med-gray); */
  border-radius: 0;
  transition: 0.3s;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  /* width: 122px;
  height: 242px; */
}

input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

input[type="radio"]:checked + label {
  border: 3px solid var(--green);
}

label:hover {
  background-color: var(--lt-gray);
}

.flex {
  display: flex wrap;
  margin: 30px 0;
  justify-content: center;
}

.one {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.two {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/60%;
}

.three {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.four {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.five {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.six {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.btn {
  background-color: var(--green);
  color: var(--white);
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14rem;
  line-height: 1.143;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 165px;
  height: 30px;
  transition: 0.3s;
  margin-bottom: 20px;
}

.btn:hover {
  background-color: var(--dk-green);
}

.link {
  font-family: var(--roboto);
  font-size: 14rem;
  line-height: 1.143;
  font-weight: 500;
  color: var(--emerald);
  text-decoration: none;
  margin-top: auto;
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.photo {
  width: 41%;
  max-width: 472px;
  object-fit: cover;
  flex: 0 0 auto;
  margin-left: auto;
}

.badge-img {
  display: block;
  box-sizing: border-box;
  transition: 0.3s;
  max-width: 240px;
}

.badge-img:hover {
  filter: brightness(85%);
}

.alert {
  margin-bottom: 20px;
  font-size: 12rem;
}

@media (min-width: 768px) {
  .content {
    padding: 70px 0 70px 5%;
    width: 59%;
  }
}
</style>
